import { decodeHTML } from 'entities';

export const sanitizeText = (text: string): string => {
  if (!text) return '';
  // {0,2000}: caps per-opener backtracking to O(1), keeping overall cost O(n).
  return decodeHTML(text.replace(/<[^>]{0,2000}>/g, ''));
};
